import { Param } from "../../../query-options";
import { HomePageActionDialogReturnObj, PerformActionParamObj } from "../extras";
import { HomePageActionBase } from "./home-page-base-action"
import { IHomePageAction } from "./i-home-page-action";

export class PublishFolderAction extends HomePageActionBase implements IHomePageAction{

    public getTitle(): string {
        return "Publish Folder";
    }

    public permissionsRequiredToPerform(): string {
        return "CanViewFolder";
    }

    public requiresTree(): boolean {
        return true;
    }

    // Some IHomePageAction implementations "do" more (for example, some call services which create objects)
    // But all this one does is set a Folder Id on the returned object - this can be used to open the Document Publishing dialog
    // (something it wouldn't make sense to do here)
    public performAction(paramObj: PerformActionParamObj): Promise<HomePageActionDialogReturnObj> {
        let returnObj = new HomePageActionDialogReturnObj();
        returnObj.folderToPublish = paramObj.folderId;

        return new Promise((resolve) => {
            resolve(returnObj);
        });
    }

}
